export default {
  // Navigation
  'nav.timer': 'المؤقت',
  'nav.stopwatch': 'الساعة الإيقافية',
  'nav.worldclock': 'الساعة العالمية',
  'nav.timestamp': 'الطابع الزمني',
  'nav.home': 'الصفحة الرئيسية',

  // Common buttons and actions
  'button.start': 'ابدأ',
  'button.pause': 'إيقاف مؤقت',
  'button.stop': 'توقف',
  'button.reset': 'إعادة تعيين',
  'button.ok': 'موافق',
  'button.cancel': 'إلغاء',
  'button.close': 'إغلاق',
  'button.save': 'حفظ',
  'button.delete': 'حذف',
  'button.edit': 'تحرير',
  'button.back': 'رجوع',
  'button.next': 'التالي',
  'button.previous': 'السابق',
  'button.submit': 'إرسال',
  'button.confirm': 'تأكيد',
  'button.convert': 'تحويل',
  'button.copy': 'نسخ',
  'button.copied': 'تم النسخ!',
  'button.now': 'الآن',
  'button.clear': 'مسح',

  // Common labels
  'label.hours': 'الساعات',
  'label.minutes': 'الدقائق',
  'label.seconds': 'الثواني',
  'label.milliseconds': 'الميلي ثانية',
  'label.minute': 'دقيقة',
  'label.second': 'ثانية',
  'label.sound': 'الصوت',
  'label.soundAlert': 'الصوت',
  'label.fullscreen': 'ملء الشاشة',
  'label.language': 'اللغة',
  'label.selectLanguage': 'اختر اللغة',
  'label.languageSelectorInfo': 'تدعم حالياً {{count}} لغة. اختر لغتك المفضلة من الخيارات أعلاه.',

  // Common messages
  'message.timerComplete': 'انتهى المؤقت!',
  'message.timerCompleteDesc': 'انتهى المؤقت الخاص بك',
  'message.timerCompleteBody': 'انتهى المؤقت العكسي الخاص بك!',
  'message.stopwatchStarted': 'بدأت الساعة الإيقافية',
  'message.stopwatchStartedDesc': 'بدأ توقيت الساعة الإيقافية',
  'message.stopwatchStopped': 'توقفت الساعة الإيقافية',
  'message.stopwatchStoppedDesc': 'تم إيقاف توقيت الساعة الإيقافية',
  'message.stopwatchReset': 'تم إعادة تعيين الساعة الإيقافية',
  'message.stopwatchResetDesc': 'تم إعادة تعيين الساعة الإيقافية إلى الصفر',
  'message.notificationPermission': 'السماح بالإشعارات للحصول على تنبيهات عند انتهاء المؤقت',
  'message.clickToEdit': 'انقر على أرقام الوقت لتعديل الوقت مباشرة',
  'message.addHours': '+ إضافة ساعات',
  'message.escToExit': 'اضغط على ESC للخروج من ملء الشاشة',
  'message.timeRemaining': '{{minutes}} دقيقة {{seconds}} ثانية متبقية',
  'message.minutesRemaining': '{{minutes}} دقيقة متبقية',
  'message.secondsRemaining': '{{seconds}} ثانية متبقية',
  'message.stopwatchTimeElapsed': '{{minutes}} دقيقة {{seconds}} ثانية مضت',
  'message.stopwatchMinutesElapsed': '{{minutes}} دقيقة مضت',
  'message.stopwatchSecondsElapsed': '{{seconds}} ثانية مضت',
  'message.invalidTimestamp': 'طابع زمني غير صحيح',
  'message.invalidDateTime': 'تاريخ ووقت غير صحيح',
  'message.conversionError': 'خطأ في التحويل',

  // Time units
  'time.am': 'صباحاً',
  'time.pm': 'مساءً',
  'time.now': 'الآن',
  'time.today': 'اليوم',
  'time.yesterday': 'أمس',
  'time.tomorrow': 'غداً',

  // Common errors
  'error.pageNotFound': 'الصفحة غير موجودة',
  'error.somethingWrong': 'حدث خطأ ما',
  'error.tryAgain': 'يرجى المحاولة مرة أخرى لاحقاً',

  // Footer
  'footer.about': 'حول timer.today',
  'footer.aboutDesc': 'timer.today هو منصة أداة توقيت احترافية عبر الإنترنت توفر ثلاث ميزات أساسية:',
  'footer.timerDesc': 'أداة عد تنازلي قابلة للتخصيص مع دعم إعدادات الدقائق والساعات، مثالية للتركيز على العمل وجدولة الطهي وإدارة الدراسة وغير ذلك. تتميز بتنبيهات صوتية والإشعارات المكتبية.',
  'footer.stopwatchDesc': 'أداة توقيت عالية الدقة بدقة الميلي ثانية، مناسبة للتدريب الرياضي وعمليات الطهي واختبارات الامتحان وغيرها من السيناريوهات التي تتطلب توقيت دقيق.',
  'footer.worldClockDesc': 'عرض فوري لأوقات المدن الرئيسية حول العالم مع حسابات المنطقة الزمنية الذكية، مما يسهل التواصل التجاري الدولي والتعاون عبر المناطق الزمنية.',
  'footer.timestampDesc': 'محول الطابع الزمني Unix يدعم التحويل ثنائي الاتجاه بين الطابع الزمني والتاريخ والوقت، مع دعم تنسيقات الثواني والميلي ثانية.',
  'footer.termsOfService': 'شروط الخدمة',
  'footer.privacy': 'الخصوصية',
  'footer.contactUs': 'اتصل بنا',
  'footer.changeLanguage': 'تغيير اللغة',
  'footer.moreLanguage': 'لغات أخرى',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 ثانية',
  'quick.add1min': '+1 دقيقة',
  'quick.add5min': '+5 دقائق',
  'quick.add10min': '+10 دقائق',
  'quick.add30min': '+30 دقيقة',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'مؤقت {{minutes}} دقيقة',
  'breadcrumb.timer': 'المؤقت',
  'breadcrumb.stopwatch': 'الساعة الإيقافية',
  'breadcrumb.worldClock': 'الساعة العالمية',
  'breadcrumb.termsOfService': 'شروط الخدمة',
};